import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ArticleCard from '@/components/base/ArticleCard';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);

  if (!category) {
    return (
      <>
        <ScrollToTop />
        <Navbar />
        <div className="pt-24 pb-10 text-center">
          <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center bg-secondary-100 rounded-full">
            <i className="ri-emotion-sad-line text-3xl text-secondary-500"></i>
          </div>
          <h1 className="text-xl font-heading text-foreground-900 mb-2">分类未找到</h1>
          <p className="text-sm text-foreground-500 mb-6">该分类不存在或已被移除</p>
          <Link
            to="/"
            className="inline-flex px-5 py-2.5 bg-primary-500 text-white font-medium rounded-full whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          >
            返回首页
          </Link>
        </div>
        <Footer />
      </>
    );
  }

  const categoryArticles = articles.filter((a) => a.categorySlug === slug);

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: `${category.name} - 黑料导航`,
    description: `黑料导航${category.name}分类，聚合最新${category.name}内容，持续更新，一网打尽。`,
    url: `https://heiliaodaohang.com/category/${slug}`,
    isPartOf: {
      '@type': 'WebSite',
      name: '黑料导航',
      url: 'https://heiliaodaohang.com',
    },
  };

  return (
    <>
      <ScrollToTop />
      <SEOHead
        title={`${category.name} - 黑料导航 | 最新${category.name}聚合`}
        description={`黑料导航${category.name}分类，为你聚合最新最全的${category.name}内容。明星黑料、网红爆料、娱乐八卦持续更新，一网打尽热门黑料。`}
        keywords={`${category.name},黑料导航,娱乐黑料,明星黑料网站,黑料资源入口,最新黑料合集`}
        canonicalUrl={`https://heiliaodaohang.com/category/${slug}`}
        ogImage="https://readdy.ai/api/search-image?query=Chinese%20entertainment%20news%20category%20page%2C%20grid%20of%20news%20thumbnails%2C%20bold%20red%20accents%2C%20modern%20web%20layout%2C%20dramatic%20style&width=1200&height=630&seq=og-category&orientation=landscape"
        schema={webPageSchema}
      />

      <Navbar />

      <main className="pt-20 md:pt-24 pb-10">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-6xl mx-auto">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: category.name },
              ]}
            />

            <div className="flex items-center gap-4 mb-8">
              <div className="w-12 h-12 flex items-center justify-center bg-primary-100 rounded-xl">
                <i className={`${category.icon} text-2xl text-primary-600`}></i>
              </div>
              <div>
                <h1 className="text-2xl md:text-3xl font-heading text-foreground-900">{category.name}</h1>
                <p className="text-sm text-foreground-500 mt-1">
                  共 {categoryArticles.length} 篇内容 · 持续更新中
                </p>
              </div>
            </div>

            <div className="flex flex-wrap gap-2 mb-8">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                    cat.slug === slug
                      ? 'bg-primary-500 text-white'
                      : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                  }`}
                  onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                >
                  {cat.name}
                </Link>
              ))}
            </div>

            {categoryArticles.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {categoryArticles.map((article) => (
                  <ArticleCard key={article.id} {...article} />
                ))}
              </div>
            ) : (
              <div className="text-center py-16">
                <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center bg-secondary-100 rounded-full">
                  <i className="ri-inbox-line text-3xl text-secondary-500"></i>
                </div>
                <p className="text-foreground-500">该分类暂无内容，敬请期待</p>
              </div>
            )}
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
}